var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          stripe: false,
          "search-btn-hide": "",
          "right-toolbar-hide": "",
          "row-key": "id",
          "reset-data": _vm.resetDataFn,
          lazy: "",
          load: _vm.loadMethod,
          "row-style": _vm.$treeRowStyleFun,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          afterFetchData: _vm.handleAfterFetchData,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "left",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "skuName"
                                      ? _c(
                                          "span",
                                          [
                                            scope.row.giftFlag
                                              ? _c("el-tag", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "SourcingDetails.form.Gift"
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(
                                              " " + _vm._s(scope.row.skuName)
                                            ),
                                          ],
                                          1
                                        )
                                      : col.prop === "skuNum"
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.skuNum) +
                                              _vm._s(scope.row.num)
                                          ),
                                        ])
                                      : col.prop === "sourcingStatus" &&
                                        scope.row.BJ_HAS_CHILD
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(
                                                    scope.row.sourcingStatus
                                                  )
                                                )
                                              )
                                          ),
                                        ])
                                      : col.prop === "sourcingStatus" &&
                                        !scope.row.BJ_HAS_CHILD
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                          ),
                                        ])
                                      : col.prop === "other"
                                      ? [
                                          !scope.row.BJ_HAS_CHILD
                                            ? _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "table-other-td-item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "SourcingDetails.form.warehouse"
                                                          )
                                                        ) +
                                                        " : " +
                                                        _vm._s(
                                                          scope.row
                                                            .stockWarehouseCode
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "table-other-td-item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "SourcingDetails.form.Shipment"
                                                          )
                                                        ) +
                                                        " : " +
                                                        _vm._s(
                                                          scope.row
                                                            .stockWarehouseName
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "table-other-td-item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "SourcingDetails.form.Failure"
                                                          )
                                                        ) +
                                                        " : " +
                                                        _vm._s(
                                                          scope.row.failReason
                                                        )
                                                    ),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDetail(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "paginationLeft",
            fn: function () {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("SourcingDetails.form.Total")) +
                      " " +
                      _vm._s(_vm.resNumberOfElements)
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }